module.exports = __webpack_public_path__ + "img/banner-dashboard.facdbdb5.jpg";